// ----------------------------------------------
//            Set up the environment
// ----------------------------------------------

var win = $(window);

var APP = {
    isProduction: true,
    touch: isTouch ? true : false,
    mobileView: false,
    desktopView: false,
    View: false,
    mobileBreakpoint: 640,
    matchMediaSupport: typeof window.matchMedia != 'undefined',
    transitionEndEvent: whichTransitionEndEvent(),
    animationEndEvent: whichAnimationEndEvent(),
    supportsAnimations: Modernizr.cssanimations
};

APP.Elements = {
    html: $(document.documentElement),
    body: $(document.body),
    header: $('.js-masthead').eq(0).parent(),
    footer: $('.js-footer').eq(0),
    wrapper: $('.js-main-wrapper').eq(0)
};

APP.Elements.header.data('height', APP.Elements.header.outerHeight());
APP.Elements.footer.data('height', APP.Elements.footer.outerHeight());


// Detect view
detectView();

// Init the RAF polyfill
AnimationFrame.shim();

// Window events
win.data('scrollPosition', win.scrollTop());
win.data('width', window.innerWidth);
win.data('height', window.innerHeight);

win.on("load scroll resize", function() {
    //new Debouncer(function() {
        win.data('scrollPosition', win.scrollTop());
    //}).handleEvent();
});
win.on("resize", function() {
    win.data('width', window.innerWidth);
    win.data('height', window.innerHeight);
});

if (APP.touch) {
    APP.Elements.body.bind('touchstart', function() {});
    FastClick.attach(document.body);
}
